<template>
  <div>
    <v-row v-for="(item, i) in list" :key="i">
      <v-col class="px-0">
        <p class="font-weight-bold fontGrey--text text-h5">ללקוח אין חבילת  {{ serviceName(item) }}</p>
        <p class=" secondary--text text-h5">חבילה מומלצת</p>
    
        <v-btn
          plain
          text
          x-large
          class="text-right pr-5 text-h6"
          @click="openService(i)"
        >
          <span class="text-decoration-underline">
            {{ contentForService(item) }}
          </span>
          <br />
          <span class="font-weight-normal text-decoration-none">
            <!-- הוסף מספר -->
            הוסף {{ item === "extra_did" ? "מספר" : "חבילה" }} 
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import subscriptions from "@/mixins/subscriptions";

export default {
  name: "RoamingSubscriptionsToAdd",
  mixins: [subscriptions],

  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    hasMissingTypes: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasSubscriptions: {
      type: Boolean,
      required: false,
      default: false,
    },
    missingTypes: {
        type: Array,
        required: false,
        default: () => [],
    },
    roamingTypes: {
        type: Array,
        required: true,
        default: () => ["international_calls", "roaming", "extra_did"],
    },
  },
};
</script>
